/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_Get_StartedInputs */

const en_common_nav_get_started = /** @type {(inputs: Common_Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const zh_common_nav_get_started = /** @type {(inputs: Common_Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始使用`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Common_Nav_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_get_started = /** @type {((inputs?: Common_Nav_Get_StartedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_Get_StartedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_get_started(inputs)
	return zh_common_nav_get_started(inputs)
});
export { common_nav_get_started as "common.nav.get_started" }